import styled from "styled-components";

// Estilização para o container das tabs
export const StyledTabsContainer = styled.div`
  margin-top: 24px;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 12px 20px;
    font-size: 16px;
    transition: all 0.3s;
  }

  .ant-tabs-tab-active {
    font-weight: 500;
  }

  .ant-tabs-ink-bar {
    height: 3px;
  }

  .ant-tabs-content {
    padding-top: 24px;
  }
`;
